import {
  Component,
  Prop, Ref,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';
import { SubMenuModel } from '@/models/SubMenuModel';

@Component
export default class MenuSelectBase extends Vue {
  @Prop() private readonly activeCategoryId!: string | null;

  @Prop() protected readonly categoryIdPrefix!: string;

  @Ref('categoryRef') protected readonly categoryRef!: HTMLSpanElement;

  protected value: SubMenuModel | null = null;

  private timeout: number | null = null;

  @Watch('activeCategoryId')
  private onActiveCategoryIdChanged(id: string): void {
    const newVal = this.submenus.find((e) => e.id === Number(id)) || null;
    this.startTransition(this.value, newVal);
    this.value = newVal;
  }

  protected get merchant(): MerchantDetailsModel {
    return this.$store.state.merchant.merchant;
  }

  protected get submenus(): SubMenuModel[] {
    return this.merchant.menus
      .filter((e) => e.visible)
      .flatMap((e) => e.submenus.map(
        (submenu) => ({ ...submenu, name: submenu.name.toLowerCase() }),
      ));
  }

  protected async onSelected(value: SubMenuModel): Promise<string> {
    return this.$vuetify.goTo(`#${this.categoryIdPrefix}${value.id}`, {
      offset: 64,
      duration: 1000,
      easing: 'easeInCubic',
    });
  }

  private startTransition(oldValue: SubMenuModel | null, newValue: SubMenuModel | null): void {
    if (oldValue === newValue) return;

    let up: boolean;
    if (!newValue) {
      up = true;
    } else if (!oldValue) {
      up = false;
    } else {
      up = this.submenus.indexOf(oldValue) > this.submenus.indexOf(newValue);
    }

    const el = this.categoryRef;

    el.style.transition = 'opacity 100ms ease-out';
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;

      el.style.opacity = '0.5';
      el.style.transform = `translate3d(0px, ${up ? '-' : ''}40%, 0px)`;
    } else {
      el.style.opacity = '0';
      el.style.transform = `translate3d(0px, ${up ? '-' : ''}70%, 0px)`;
    }

    this.timeout = setTimeout(() => {
      el.style.transition = 'opacity 150ms ease-out, transform 150ms ease-out';
      el.style.opacity = '1';
      el.style.transform = 'translate3d(0px, 0%, 0px)';
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }, 50);
  }
}
